import { memo } from "react";
import { HStack } from "@/shared/ui/Stack";
import { ALIGN_ICONS } from "../../constants/alignIcons";
import { MenuButton } from "../MenuButton/MenuButton";
import styles from "./AlignMenu.module.css";

interface AlignMenuContentProps {
    onClick: (align: string) => void;
}

export const AlignMenuContent = memo(function AlignMenuContent({ onClick }: AlignMenuContentProps) {
    return (
        <HStack className={styles.wrapper} wrap="wrap" gap={4}>
            {Object.entries(ALIGN_ICONS).map(([align, Icon]) => (
                <MenuButton key={align} onClick={() => onClick(align)}>
                    <Icon />
                </MenuButton>
            ))}
        </HStack>
    );
});
